import { mediasFields } from './composer'

export const getMediaBySlug = () => {
  return `query getMediaBySlug($slug: String!, $code: String) {
    medias(slug: $slug, code: $code) {
      id
      slug
      title
      titleEn
      category
      tags {
        label
        slug
      }
      type
      set
      setSlug
      place
      timestamp
      download
      summary
      summaryEn
      collectionSummary
      collectionSummaryEn
      collectionName
      collectionNameEn
      duration
      collectivities {
        id
        name
        slug
      }
      work {
        composers {
          slug
          firstName
          lastName
          birthDate
          deathDate
          photo {
            getUrl
          }
        }
        publishingStartDate
      }
      participants {
        firstName
        lastName
        slug
        role
        roleEn
      }
      event {
        title
        start
        end
        type
        slug
        location {
          name
          hall
          city {
            name
            country {
              name
            }
          }
        }
        type

      }
      img {
        url
        alt
      }
      files {
        getUrl
        getUrlSource
        originalFileName
      }
      thumbnail {
        getUrl
      }
      relatedContent {
        ${mediasFields}
      }
      programnote {
        title
        program {
          getUrl
        }
      }
      confidentiality
    }
  }`
}
